import BaseApiClient from '../BaseApiClient';
import { ListDataParams, ListDataResponse } from '../types';
import { DocumentInterface } from '@interfaces/Document.interface';

export class ApiDocument extends BaseApiClient {
  /**
   * Get list of items
   */
  async list(
    listData: ListDataParams,
    searchTerm?: string
  ): Promise<ListDataResponse<DocumentInterface>> {
    return new Promise((resolve, reject) => {
      if (searchTerm) {
        if (!listData.filters) listData.filters = {};
        listData.filters.file_name = searchTerm;
      }
      delete listData.filters?.sort;
      delete listData.filters?.task_uuid;
      delete listData.filters?.page;
      delete listData.filters?.perPage;

      this.client
        .getList('/documents', listData)
        .then((res) => {
          if (res.data) {
            resolve({
              items: res.data.data,
              pagination: {
                page: res.data.meta?.current_page,
                perPage: res.data.meta?.per_page,
                total: res.data.meta?.total
              }
            });
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Get an item
   */
  async get(id: number): Promise<DocumentInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .get(`/documents/${id}`)
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Store an item
   */
  async store(dto: {
    owner_uuid: string;
    file_name: string;
    docs: File | null;
    document_category_id: number;
  }): Promise<DocumentInterface> {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      for (const [key, value] of Object.entries(dto)) {
        formData.set(key, value as string | Blob);
      }
      this.client
        .post('/documents', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Delete an item
   */
  async delete(id: number) {
    return this.client.delete(`/documents/${id}`);
  }

  /**
   * Delete multiple items
   */
  async deleteMultiple(ids: number[]) {
    // TODO: replace with a BE mass delete endpoint once available
    return Promise.all(ids.map((id) => this.delete(id)));
  }
}

export { documentQueryKeys } from './query-keys';
export type { DocumentListParams } from './query-keys';
export { useDocumentListQuery, useDocumentQuery } from './use-document-queries';
export {
  useDocumentDeleteMutation,
  useDocumentDeleteMultipleMutation,
  useDocumentStoreMutation
} from './use-document-mutations';

